import React from 'react'
import { useSendMessageModal } from './hooks/useSendMessageModal'

import Modal from '../../../../shared/ui/Modal/Modal'
import Toast from '../../../../shared/ui/Toast/Toast'
import StepSendMessageOne from './steps/SendMessageStep/SendMessageStep'

import { ReactComponent as TitleIcon } from '../../../../assets/icons/send_icon.svg'

const SendMessageModal = ({
	isOpen,
	onClose,
	selectedStudents = [],
	selectedParents = [],
	initialMessage = '',
	onAfterSendSuccess = null,
}) => {
	const {
		cursorOffsetRef,
		messageEditorRef,
		visibleStudents,
		hiddenStudentsCount,
		showAllStudents,
		toggleShowAllStudents,
		visibleParents,
		hiddenParentsCount,
		showAllParents,
		toggleShowAllParents,
		removeStudent,
		addParents,
		setAddParents,
		messageText,
		setMessageText,
		insertStudentName,
		insertParentName,
		close,
		footerActions,
		showToast,
		closeToast,
		sendError,
		successToastMessage,
	} = useSendMessageModal({
		isOpen,
		onClose,
		selectedStudents,
		selectedParents,
		initialMessage,
		onAfterSendSuccess,
	})

	return (
		<>
			<Modal
				isOpen={isOpen}
				onClose={close}
				title="Send Message"
				iconTitle={TitleIcon}
				width={568}
				maxHeight={648}
				footerButtons={footerActions}
				ariaLabel="Send Message"
			>
				{sendError ? (
					<p
						style={{
							color: 'var(--color-red, #c00)',
							margin: '0 0 12px',
							fontSize: 14,
						}}
					>
						{sendError}
					</p>
				) : null}
				<StepSendMessageOne
					cursorOffsetRef={cursorOffsetRef}
					messageEditorRef={messageEditorRef}
					visibleStudents={visibleStudents}
					hiddenStudentsCount={hiddenStudentsCount}
					showAllStudents={showAllStudents}
					toggleShowAllStudents={toggleShowAllStudents}
					visibleParents={visibleParents}
					hiddenParentsCount={hiddenParentsCount}
					showAllParents={showAllParents}
					toggleShowAllParents={toggleShowAllParents}
					removeStudent={removeStudent}
					addParents={addParents}
					setAddParents={setAddParents}
					messageText={messageText}
					setMessageText={setMessageText}
					insertStudentName={insertStudentName}
					insertParentName={insertParentName}
				/>
			</Modal>

			<Toast
				isVisible={showToast}
				message={successToastMessage}
				onClose={closeToast}
			/>
		</>
	)
}

export default SendMessageModal
